import { render } from "./UserNew.vue?vue&type=template&id=c06bcd36&scoped=true"
import script from "./UserNew.vue?vue&type=script&lang=js"
export * from "./UserNew.vue?vue&type=script&lang=js"

import "./UserNew.vue?vue&type=style&index=0&id=c06bcd36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c06bcd36"

export default script